import React, { useState } from "react";
import { Select, Typography } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Option } = Select;

// Function to calculate dynamic date ranges
const getDateRanges = () => {
    const today = dayjs(); // Current Date

    const last7DaysStart = today.subtract(6, "days").format("MMM DD, YYYY");
    const last7DaysEnd = today.format("MMM DD, YYYY");

    const lastWeekStart = today.subtract(7, "days").startOf("week").format("MMM DD, YYYY");
    const lastWeekEnd = today.subtract(7, "days").endOf("week").format("MMM DD, YYYY");

    const thisMonthStart = today.startOf("month").format("MMM DD, YYYY");
    const thisMonthEnd = today.endOf("month").format("MMM DD, YYYY");

    const last30DaysStart = today.subtract(29, "days").format("MMM DD, YYYY");
    const last30DaysEnd = today.format("MMM DD, YYYY");

    const lastMonthStart = today.subtract(1, "month").startOf("month").format("MMM DD, YYYY");
    const lastMonthEnd = today.subtract(1, "month").endOf("month").format("MMM DD, YYYY");

    return [
        { label: `Last 7 Days: ${last7DaysStart} - ${last7DaysEnd}`, value: "last7days" },
        { label: `Last Week: ${lastWeekStart} - ${lastWeekEnd}`, value: "lastweek" },
        { label: `This Month: ${thisMonthStart} - ${thisMonthEnd}`, value: "thismonth" },
        { label: `Last 30 Days: ${last30DaysStart} - ${last30DaysEnd}`, value: "last30days" },
        { label: `Last Month: ${lastMonthStart} - ${lastMonthEnd}`, value: "lastmonth" },
    ];
};

const DateRangeDropdown: React.FC = () => {
    const dateRanges = getDateRanges(); // Dynamically generate date ranges
    const [selectedRange, setSelectedRange] = useState<string>(dateRanges[0].value);

    const handleChange = (value: string) => {
        setSelectedRange(value);
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <CalendarOutlined style={{ fontSize: "18px", color: "#1890ff" }} />
            <Select
                value={selectedRange}
                onChange={handleChange}
                style={{ minWidth: 200 }}
                size="middle"
                dropdownStyle={{ fontSize: "14px" }}
            >
                {dateRanges.map((range) => (
                    <Option key={range.value} value={range.value}>
                        {range.label}
                    </Option>
                ))}
            </Select>
        </div>
    );
};

export default DateRangeDropdown;
